module.exports = __webpack_public_path__ + "static/media/instagram.00ab1b70.svg";